interface Description {
  title: string;
  title_2: string;
  title_3: string;
  content: string[];
}

interface Story {
  title: string;
  content: string[];
}

interface Schedule {
  dayNightHeadline: string;
  content: string[];
}

interface TicketSubsidyNote {
  boxTitle: string;
  /** base/sm: white-space: pre-line 用 */
  introSm: string;
  /** md 以上: 1段落（Chrome 等はブラウザ任せ折り返し） */
  introMd: string;
  /** md 以上・Safari のみ: 添付デザインと同じ3行 */
  introMdSafari: string;
  /** base/sm: 細かく改行 */
  boxBodySm: string;
  /** md 以上: 元デザイン（全5行） */
  boxBodyMd: string;
  footerSm: string;
  footerMd: string;
}

interface Ticket {
  content: string[];
  SameDayTicket: string[];
  AdditionalSales: string[];
  SubsidyNote: TicketSubsidyNote;
}

interface TicketSales {
  content: string[];
  StadiumCityAppSecondRound: string[];
  FirstRound: string[];
  prereserveSecondRound: string[];
  GeneralSales: string[];
}

interface Performer {
  content: string[];
}

interface Cautions {
  content: string[];
}

interface Credits {
  content: string[];
}

interface Texts {
  TOPGUN_TITLE: string;
  TOPGUN_TITLE_2: string;
  TOPGUN_TITLE_3: string;
  CONTENT: string;
  MAIN_CONTENT_2: string;
  MAIN_CONTENT_3: string;
  MAIN_CONTENT_4: string;
  MAIN_CONTENT_5: string;
  MAIN_CONTENT_6: string;
  MAIN_CONTENT_7: string;
  MAIN_CONTENT_8: string;
  MAIN_CONTENT_9: string;
  MAIN_CONTENT_10: string;
  MAIN_CONTENT_11: string;
  MAIN_CONTENT_12: string;
  Description: Description;
  Story: Story;
  Schedule: Schedule;
  Ticket: Ticket;
  TicketSales: TicketSales;
  Performer: Performer;
  Cautions: Cautions;
  Credits: Credits;
}

export const TEXTS: Texts = {
  TOPGUN_TITLE: "歴史的大ヒット『トップガン マーヴェリック』",
  TOPGUN_TITLE_2: "東京では即日SOLD OUTとなった超話題作！",
  TOPGUN_TITLE_3: "全世代待望のシネマコンサートがついに長崎上陸！",
  CONTENT:
    "日本では2022年5月に公開され、興行収入が驚異の137億円を突破した\n映画『トップガン マーヴェリック』",
  MAIN_CONTENT_2: "2022年の国内映画興行収入ランキングで洋画部門第1位を獲得し、",
  MAIN_CONTENT_3:
    "全世界ではトム・クルーズの\u200Bキャリア最高額と\u200Bなる10億ドル超えの\u200B大ヒットを記録！",
  MAIN_CONTENT_4: "まさに映画史に名を刻む伝説の作品となった。",
  MAIN_CONTENT_5:
    "そんな大ヒット作品をオーケストラの極上の生演奏とともに上映し、",
  MAIN_CONTENT_6:
    "イギリスやドイツをはじめ全世界10都市以上で大好評を博し、\n去年には東京、大阪も熱狂の渦に巻き込んだ",
  MAIN_CONTENT_7:
    "「トップガン マーヴェリック シネマコンサート」が\n遂に長崎で開催決定！",
  MAIN_CONTENT_8: "日本中に熱狂を巻き起こした『トップガン マーヴェリック』を",
  MAIN_CONTENT_9:
    "＜大スクリーンでの映画全編上映 × オーケストラによる大迫力の生演奏\u2060＞\u2060でお届けする、",
  MAIN_CONTENT_10: "全世代が楽しめる最高のエンターテインメント・コンサート！",
  MAIN_CONTENT_11:
    "長崎スタジアムシティの「トップガン マーヴェリック シネマコンサート」で",
  MAIN_CONTENT_12:
    "熱い感動と興奮に満ちた忘れられないひとときをお楽しみください！",
  Description: {
    title: "「シネオケ",
    title_2: "®",
    title_3: "とは？」",
    content: [
      "“大スクリーンでの映画上映 × オーケストラ生演奏による音楽”でお届けする\n新たなスタイルのコンサート「シネオケ®」。",
      "演奏を聴くだけではなく、映画そのものを大スクリーンで楽しめるので、\n大迫力の「映像」とオーケストラの極上の演奏による「音楽」の両方を卓越した臨場感で体験でき、\n作品の世界観に没入できます。",
      "「シネオケ®」は、株式会社キョードー東京の商標です。",
    ],
  },
  Story: {
    title: "上映作品",
    content: [
      "トップガン マーヴェリック",
      "(2022年公開作品）",
      "英語上映・日本語字幕 / 上映時間：約2時間15分（休憩除く）",
      "監督 : ジョセフ・コジンスキー",
      "音楽 : ローン・バルフ、ハロルド・フォルターメイヤー、\nレディー・ガガ、ハンス・ジマー",
      "アメリカ海軍のエリートパイロット養成学校トップガンに、",
      "伝説のパイロット、マーヴェリックが教官として帰ってきた。空の厳しさと美しさを誰よりも知る彼は、",
      "守ることの難しさと戦うことの厳しさを教えるが、訓練生たちはそんな彼の型破りな指導に戸惑い反発する。",
      "その中には、かつてマーヴェリックとの訓練飛行中に命を落とした相棒グースの息子ルースターの姿もあった。",
      "ルースターはマーヴェリックを恨み、彼と対峙するが……。",
      "ABOUT THE MOVIE",
      "※途中20分のインターミッション有、公演全体は2時間35分予定",
    ],
  },
  Schedule: {
    dayNightHeadline: "昼夜 2 公演",
    content: [
      "2026年",
      "8",
      "月",
      "22",
      "日",
      "（土）",
      "昼の部　開場 12:00 開演 13:00",
      "夜の部　開場 17:00 開演 18:00",
      "※英語上映・日本語字幕",
      "会場",
      "長崎スタジアムシティ HAPPINESS ARENA",
      "〒850-0046 長崎県長崎市幸町7-1",
      "（外部リンク）",
    ],
  },
  Ticket: {
    content: [
      "料金",
      "S席 9,900 円",
      "A席 8,800 円",
      "B 席/見切り席 5,800 円",
      "全席指定席・税込",
      "CN プレイガイド",
      "ご購入はこちらから",
      "全席指定席・税込",
      "お問い合わせ",
      "長崎スタジアムシティ 0120-1014 -77",
      "（9時～22時）",
      "VIP席 12,800 円",
      "（ドリンク代 ＋ 部屋の利用料含む）",
    ],
    SubsidyNote: {
      boxTitle: "～長崎市くらしの魅力創出事業費補助金とは～",
      introSm: [
        "「トップガンマーベリック シネマコンサート」は、",
        "長崎市くらしの魅力創出事業費補助金の活用により",
        "販売する予定で、",
        "現在申請に向けた準備を行っています。",
      ].join("\n"),
      introMd:
        "「トップガンマーベリック シネマコンサート」は、長崎市くらしの魅力創出事業費補助金の活用により販売する予定で、現在申請に向けた準備を行っています。",
      introMdSafari: [
        "「トップガンマーベリック シネマコンサート」は、",
        "長崎市くらしの魅力創出事業費補助金の活用により販売する予定で、",
        "現在申請に向けた準備を行っています。",
      ].join("\n"),
      boxBodySm: [
        [
          "長崎スタジアムシティで開催される演劇やコンサート、",
          "スポーツなどのイベントを、",
          "より多くの長崎市民に楽しんでいただくための長崎市の事業。",
        ].join("\n"),
        [
          "「長崎スタジアムシティ連携わくわく・",
          "賑わい創出プロジェクト」",
          "に寄せられた企業からの寄付金を活用し、",
          "長崎市がイベント主催者に費用の補助を行い、",
          "長崎市民の皆さんが割引価格で鑑賞できる座席を実現するものです。",
        ].join("\n"),
      ].join("\n\n"),
      boxBodyMd: [
        [
          "長崎スタジアムシティで開催される演劇やコンサート、スポーツなどのイベントを、",
          "より多くの長崎市民に楽しんでいただくための長崎市の事業。",
        ].join("\n"),
        [
          "「長崎スタジアムシティ連携わくわく・賑わい創出プロジェクト」",
          "に寄せられた企業からの寄付金を活用し、長崎市がイベント主催者に費用の補助を行い、",
          "長崎市民の皆さんが割引価格で鑑賞できる座席を実現するものです。",
        ].join("\n"),
      ].join("\n\n"),
      footerSm: [
        [
          "補助金対象の座席に関しては、",
          "後方の座席や一部見えにくい可能性のあるお席となります。",
        ].join("\n"),
        "なお、こちらの受付の期間は6月下旬から7月上旬を予定しております。",
      ].join("\n\n"),
      footerMd: [
        "補助金対象の座席に関しては、後方の座席や一部見えにくい可能性のあるお席となります。",
        "なお、こちらの受付の期間は6月下旬から7月上旬を予定しております。",
      ].join("\n"),
    },
    AdditionalSales: [
      "追加販売",
      "注釈付き 見切れS席",
      "（追加販売・先着）",
      "2025年8月1日(金) 正午12:00～",
      "お申込み",
      "※ステージ全体や出演者、映像および演出の一部が見えづらい場合がございます。",
      "注釈付き 見切れS席 9,900 円",
      "※スピーカーが近いため、音量が大きいと感じる場合がございます。",
    ],

    SameDayTicket: [
      "当日券について",
      "S席 10,400 円",
      "A席 9,300 円",
      "当日券は、開場時刻の15:00より、\n大阪城ホール北口当日券販売所で販売いたします。",
      "お支払方法は現金のみとなりますので、予めご了承ください。",
      "※当日券は数に限りがございます。",
      "予定枚数に達し次第、販売終了となりますので、\nお早めにお求めください。",
    ],
  },
  TicketSales: {
    content: [
      "先行販売",
      "スタジアムシティアプリ 1次先行",
      "受付期間：2026年5月22日(金) 18:00 〜 5月31日(日) 23:59",
      "お申込み",
      "一般販売",
      "一般販売",
      "10/11(土)10:00 〜",
      "COMING SOON",
      "（抽選）",
      "（先着）",
      "受付終了",
    ],
    FirstRound: [
      "プレリザーブ 1次先行",
      "受付期間：2026年6月1日(月) 11:00 〜 6月10日(水) 11: 00",
      "Pコード：325-364",
    ],
    StadiumCityAppSecondRound: [
      "スタジアムシティアプリ 2次先行",
      "受付期間：2026年6月17日(水) 18:00 〜 6月28日(日) 23:59",
    ],
    prereserveSecondRound: [
      "プレリザーブ 2次先行",
      "受付期間：2026年6月29日(月) 11:00 〜 7月8日(木) 11: 00",
      "Pコード：325-364",
    ],
    GeneralSales: [
      "一般発売",
      "2026年7月18日(土) 10:00 〜 ",
      "チケットぴあ",
      "スタジアムシティアプリ",
      "ローチケ",
      "イープラス",
    ],
  },
  Performer: {
    content: [
      "指揮",
      "和田一樹",
      "東京都中野区出身。",
      `2015年第6回ブカレスト国際指揮者コンクールにて準優勝。`,
      `2017年にヤシ・モルドヴァ・フィルハーモニー管弦楽団を指揮しヨーロッパデビュー。「最年少最優秀客演指揮者」の称号を受けて以降、毎シーズン客演している。ドラマ「のだめカンタービレ」、映画「マエストロ！」等で指揮指導を担当。`,
      `これまでに、都響、東フィル、東響、新日本フィル、日本フィル、群響、神奈川フィル、などと共演、国内外で指揮活動を展開している。`,
      "2026年度より、トリフォニーホール・ジュニア・オーケストラ音楽監督に就任。",
      "演奏",
      "WOWOW シネマオーケストラ with 長崎 OMURA 室内合奏団",
      "",
    ],
  },
  Cautions: {
    content: [
      "注意事項",
      "※全席指定です。",
      "※キャストの登壇はございません。",
      "※英語上演・日本語字幕となります。",
      "※お一人様、１回につき４枚までご購入できます。",
      "※5歳未満のお子様はご入場できません。",
      "※車いすをご利用のお客様はA席をご購入いただき、",
      "　事前に長崎スタジアムシティ 0120－1014－77(9:00 ～ 22:00) まで来場の旨をご連絡ください。",
      "　（付き添いの方もチケットが必要です。）",
      "※万が一出演者が変更になった場合でも、チケットの払い戻しには対応いたしかねます。",
    ],
  },
  Credits: {
    content: [
      "“A Royal Albert Hall production” and “With thanks to esk film and Avex Classics International”　\nSymphonic Cinema Presents",
      "“Original Music Score by　\nLorne Balfe, Harold Faltermeyer, Lady Gaga and Hans Zimmer.”",
      "主催 :",
      "KTN テレビ長崎 / リージョナルエックス長崎",
      "企画・制作",
      "企画協力 :",
      "松竹音楽出版",
      "協力：",
      "キョードー東京",
    ],
  },
};
